import {http} from '@/http'

export default {
  list() {
    return http.get('/api/v1/price-types')
  },
  create(data) {
    return http.post('/api/v1/price-types', data)
  },
  update(id, data) {
    return http.put(`/api/v1/price-types/${id}`, data)
  },
  changeStatus(id, isActive) {
    return http.patch(`/api/v1/price-types/${id}/status`, { is_active: isActive })
  },
  remove(id) {
    return http.delete(`/api/v1/price-types/${id}`)
  },
  simulate(formula, baseAmount) {
    return http.get('/api/v1/price-types/simulate', {params: {formula, base_amount: baseAmount}})
  }
}
